import React, { useContext, useState } from 'react';

// Shared
import { BodyMedium, H3, H4 } from '@styled';
import SubmitButton from '@atoms/SubmitButton';
import SearchMembersByEmail from '@molecules/SearchMembersByEmail';

// Functionality
import { MembershipContext } from '../../../../context/MembershipProvider';
import { PropTypes } from 'prop-types';

const MembershipSearchByEmailForm = ({ onSuccessfulSearch }) => {
    const {
        isEmailValid,
        joinStep,
        joinSteps,
        searchStatuses,
        setIsEmailValid,
        setUser,
        setSearchStatus,
        setJoinStep,
    } = useContext(MembershipContext);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSearchCompleted = ({ email, count }) => {
        setIsEmailValid(true);
        setUser({ username: email });

        if (count === 0) {
            setSearchStatus(searchStatuses.EMAIL_NOT_FOUND);
            setJoinStep(joinSteps.SEARCH_NAME);
            return;
        }

        setSearchStatus(searchStatuses.LOGIN);
        setJoinStep(joinSteps.LOGIN);

        onSuccessfulSearch(email);
    };

    return (
        <div>
            <H3>Purchase a Membership</H3>
            <H4 className="mt-1.125rem">To join or renew, enter your email below:</H4>
            <BodyMedium className="mb-1rem mt-1rem">Already have an account? We'll prompt you to log in.</BodyMedium>
            <SearchMembersByEmail onSearchCompleted={onSearchCompleted} onSubmittingChange={setIsSubmitting} />

            {(joinStep === joinSteps.EMAIL || !isEmailValid) && (
                <SubmitButton isSubmitting={isSubmitting} submittingText="Checking email...">
                    Continue with email
                </SubmitButton>
            )}
        </div>
    );
};

MembershipSearchByEmailForm.propTypes = {
    onSuccessfulSearch: PropTypes.func.isRequired,
};

export default MembershipSearchByEmailForm;
